import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  activeRequests: 0,
};

const LoaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader: state => {
      state.isLoading = true;
    },
    hideLoader: state => {
      state.isLoading = false;
    },
    incrementActiveRequests: state => {
      state.activeRequests += 1;
    },
    decrementActiveRequests: state => {
      state.activeRequests = Math.max(0, state.activeRequests - 1);
    },
  },
});

export const {
  showLoader,
  hideLoader,
  incrementActiveRequests,
  decrementActiveRequests,
} = LoaderSlice.actions;

export default LoaderSlice.reducer;
